import React, {
  createContext,
  useContext,
  useSyncExternalStore,
} from "react";
import PropTypes from "prop-types";

import {
  assertDockingRuntime,
} from "../../../engines/StudioDockingEngine";


const DockingContext = createContext(null);


export function DockingProvider({
  runtime,
  children,
}) {
  const validatedRuntime = assertDockingRuntime(runtime);

  return (
    <DockingContext.Provider value={validatedRuntime}>
      {children}
    </DockingContext.Provider>
  );
}


DockingProvider.propTypes = {
  runtime: PropTypes.shape({
    getLayout: PropTypes.func.isRequired,
    setLayout: PropTypes.func.isRequired,
    activatePanel: PropTypes.func.isRequired,
    movePanel: PropTypes.func.isRequired,
    resizeSplit: PropTypes.func.isRequired,
    closePanel: PropTypes.func.isRequired,
    hidePanel: PropTypes.func.isRequired,
    restorePanel: PropTypes.func.isRequired,
    resetLayout: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
};


export function useDockingRuntime() {
  const runtime = useContext(DockingContext);

  if (!runtime) {
    throw new Error(
      "useDockingRuntime must be used inside DockingProvider."
    );
  }

  return runtime;
}


export function useDockingLayout() {
  const runtime = useDockingRuntime();

  return useSyncExternalStore(
    runtime.subscribe,
    runtime.getLayout,
    runtime.getLayout,
  );
}


export default DockingContext;
